import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/hakkimizda', label: 'Hakkımızda' },
    { path: '/hizmetler', label: 'Hizmetler' },
    { path: '/ornek-isler', label: 'Örnek İşler' },
    { path: '/blog', label: 'Blog' },
    { path: '/yorumlar', label: 'Yorumlar' },
    { path: '/iletisim', label: 'İletişim' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-fixed">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/70o6g2rv_WhatsApp%20G%C3%B6rsel%202025-11-07%20saat%2009.52.07_0d5a0921.jpg" 
              alt="EMRE TİCARET Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium ${
                  isActive(link.path)
                    ? 'text-yellow-500'
                    : 'text-gray-300 hover:text-yellow-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a href={`tel:${contactInfo.phones[0].number.replace(/\s/g, '')}`}>
              <Button variant="outline" className="border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black">
                <Phone className="w-4 h-4 mr-2" />
                Hemen Ara
              </Button>
            </a>
            <a href={`https://wa.me/${contactInfo.whatsapp}`} target="_blank" rel="noopener noreferrer">
              <Button className="bg-yellow-500 text-black hover:bg-yellow-600">
                WhatsApp'tan Yaz
              </Button>
            </a>
          </div>

          <button
            className="lg:hidden text-gray-300 hover:text-yellow-500"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="mobile-menu lg:hidden">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-sm font-medium ${
                    isActive(link.path)
                      ? 'text-yellow-500'
                      : 'text-gray-300 hover:text-yellow-500'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex flex-col space-y-3 pt-4 border-t border-gray-800">
                <a href={`tel:${contactInfo.phones[0].number.replace(/\s/g, '')}`}>
                  <Button variant="outline" className="w-full border-yellow-500 text-yellow-500">
                    <Phone className="w-4 h-4 mr-2" />
                    Hemen Ara
                  </Button>
                </a>
                <a href={`https://wa.me/${contactInfo.whatsapp}`} target="_blank" rel="noopener noreferrer">
                  <Button className="w-full bg-yellow-500 text-black hover:bg-yellow-600">
                    WhatsApp'tan Yaz
                  </Button>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
